module.exports = __webpack_public_path__ + "static/media/upwardArrow.876d6169.svg";